(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDiagnosisDialogController', ProcedureDiagnosisDialogController);

    ProcedureDiagnosisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProcedureDiagnosis', 'Procedure', 'Icd10'];

    function ProcedureDiagnosisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProcedureDiagnosis, Procedure, Icd10) {
        var vm = this;

        vm.procedureDiagnosis = entity;
        vm.clear = clear;
        vm.save = save;
        vm.procedures = Procedure.query();
        vm.icd10s = Icd10.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.procedureDiagnosis.id !== null) {
                ProcedureDiagnosis.update(vm.procedureDiagnosis, onSaveSuccess, onSaveError);
            } else {
                ProcedureDiagnosis.save(vm.procedureDiagnosis, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:procedureDiagnosisUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
